/**
 * WebSocket event types received from the server
 */
export enum SocketEvent {
  ConversationUpdated = 'ConversationUpdated',
  TaskUpdated = 'TaskUpdated',
  TaskProgressUpdated = 'TaskProgressUpdated',
  AgentStatusUpdated = 'AgentStatusUpdated',
  IndexStatusUpdated = 'IndexStatusUpdated',
  BillingInfoUpdated = 'BillingInfoUpdated',
  LicenseUpdated = 'LicenseUpdated',
  Reload = 'Reload'
}

/**
 * Pages where WebSocket connections should not be established
 */
export const NON_WEBSOCKET_PAGES = [
  '/human-annotations',
  '/super-admin',
  '/reset-password',
  '/sso-setup'
]
